﻿import { AppServices } from "./AppServices";

export class OrderReviewPageController {
   private appServices_ = new AppServices();
   constructor(appServices: AppServices) {
      this.appServices_ = appServices;
   }

   public validate(): boolean {
      const elAcceptTerms = document.getElementById('inp-accept-terms') as HTMLInputElement;

      if (elAcceptTerms?.checked !== true) {         
         const message = 'W celu realizacji zamówienia niezbędna jest Twoja akceptacja regulaminu.';
         this.appServices_.modalService.showMessageModal(message);
         return false;            
      }
      return true;
   }
}
